import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BadgeCheck } from "lucide-react";
import { api } from "@/lib/api";
import { VideoCard } from "@/components/ott/VideoCard";

export default function OttCreator() {
  const { id } = useParams();
  const [c, setC] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/ott/creators/${id}`).then((r) => setC(r.data)).catch(() => setErr("Creator not found.")); }, [id]);
  if (err) return <div className="py-16 text-center text-stone-600" data-testid="ott-creator-error">{err}</div>;
  if (!c) return <div className="py-16 text-center text-stone-400">Loading…</div>;
  return (
    <div className="max-w-6xl mx-auto px-4 py-6" data-testid="ott-creator-page">
      <h1 className="heading text-2xl font-black text-stone-900 flex items-center gap-2">{c.name || "Creator"}{c.trusted && <BadgeCheck size={18} className="text-emerald-600" data-testid="ott-creator-trusted" />}</h1>
      <div className="text-xs text-stone-500 mb-4">{c.videos.length} videos · {c.total_views} views</div>
      <div className="grid gap-3" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))" }}>
        {c.videos.map((v) => <VideoCard key={v.video_id} v={v} />)}
      </div>
    </div>
  );
}
